export default {
  colors: {
    active: '#62A8FC',
    lightText: '#fff',
  },
};
